import { Injectable } from '@angular/core';
import { ConfigurationsService } from '@epicuro-next/platform/configuration';
import { loginSuccess } from '@epicuro-next/state/user-state';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { interval } from 'rxjs';
import { filter, map, switchMap, takeUntil } from 'rxjs/operators';

import {
  NAMESPACE_NEWS_FEED,
  NewsfeedConfigurationKeys,
  NewsfeedConfigurations,
} from '../../configuration';
import * as actions from '../actions';

export const FEED_UPDATE_INTERVAL = 60000;

/** News feed fetch effects */
@Injectable()
export class PollingEffects {
  public onInit$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loginSuccess),
      map(() => actions.startPolling()),
    ),
  );

  public startPolling$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.startPolling),
      switchMap(() =>
        this.configuration.getConfigValue<
          NewsfeedConfigurations,
          NewsfeedConfigurationKeys.isNewsfeedEnabled
        >({
          namespace: NAMESPACE_NEWS_FEED,
          featureName: NewsfeedConfigurationKeys.isNewsfeedEnabled,
          defaultValue: false,
        }),
      ),
      filter(Boolean),
      switchMap(() => {
        let lastUpdate = new Date().toISOString();

        return interval(FEED_UPDATE_INTERVAL).pipe(
          map(() => {
            const date = lastUpdate;
            lastUpdate = new Date().toISOString();

            return actions.fetchUpdates({ date });
          }),
        );
      }),
      takeUntil(this.actions$.pipe(ofType(actions.stopPolling))),
    ),
  );

  /** Dependencies */
  constructor(
    private actions$: Actions,
    private configuration: ConfigurationsService,
  ) {}
}
